import { render, staticRenderFns } from "./PfDashboardSummary.vue?vue&type=template&id=afb02dc2"
import script from "./PfDashboardSummary.vue?vue&type=script&lang=js"
export * from "./PfDashboardSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports